/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Vendor_Return_Waiting_On_YouInputs */

const en_vendor_return_waiting_on_you = /** @type {(inputs: Vendor_Return_Waiting_On_YouInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on you · confirm or refuse · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on you · confirm or refuse · since {since}" |
*
* @param {Vendor_Return_Waiting_On_YouInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_waiting_on_you = /** @type {((inputs: Vendor_Return_Waiting_On_YouInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Waiting_On_YouInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_waiting_on_you(inputs)
});